// 9fbef606107a605d69c0edbcd8029e5d
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import countryListAbstractor from '@tcp/core/src/services/abstractors/bootstrap/countryList';
import logger from '@tcp/core/src/utils/loggerInstance';
import { getModuleX } from '@tcp/core/src/services/abstractors/common/moduleX';
import { NavigateXHR } from '@tcp/core/src/services/abstractors/account/NavigateXHR';
import { getCountriesMap, getCurrenciesMap, languageRedirect } from '@tcp/core/src/utils';
import {
  COUNTRY_SELECTOR_REDUCER_KEY,
  SESSIONCONFIG_REDUCER_KEY,
} from '@tcp/core/src/constants/reducer.constants';
import GLOBAL_CONSTANT from '@tcp/core/src/reduxStore/constants';
import { validateReduxCache } from '@tcp/core/src/utils/cache.util';
import { storeCountriesMap, storeCurrenciesMap } from '@tcp/core/src/reduxStore/actions';
import { resetCartCache } from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.actions';
import COUNTRY_SELECTOR_CONSTANTS from './CountrySelector.constants';
import { udpateSiteId, setModuleXContent } from './CountrySelector.actions';

export function* fetchModuleX({ payload = '' }) {
  try {
    const countrySelectorModuleX = yield select((state) =>
      state[COUNTRY_SELECTOR_REDUCER_KEY].get('moduleXContent')
    );
    if (!countrySelectorModuleX) {
      const result = yield call(getModuleX, payload);
      yield put(setModuleXContent(result.richText));
    }
  } catch (err) {
    yield null;
  }
}

export function* fetchCountryListData() {
  try {
    const res = yield call(countryListAbstractor.getData);
    const data = res && res.data.countryList;
    const countriesMap = getCountriesMap(data);
    const currenciesMap = getCurrenciesMap(data);
    yield all([put(storeCountriesMap(countriesMap)), put(storeCurrenciesMap(currenciesMap))]);
  } catch (error) {
    yield null;
  }
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toGMTString()}`;
  document.cookie = `${cname}=${cvalue};${expires};domain=.${
    window?.location?.hostname?.split('.')?.reverse()?.[1]
  }.${window?.location?.hostname?.split('.')?.reverse()?.[0]};path=/`;
}

export function* submitCountrySelectionData({ payload: dataToSubmit }) {
  try {
    yield put(resetCartCache());
    const {
      country: newCountry,
      language: newLanguage,
      currency: newCurrency,
      exchangevalue,
      merchantMargin,
    } = dataToSubmit;
    const languageCode =
      newLanguage === 'en' ? `${newLanguage}_US` : `${newLanguage}_${newLanguage?.toUpperCase()}`;
    const iShippingCookieValue = `${newCountry}|${languageCode}|${newCurrency}|${exchangevalue}|${merchantMargin}`;
    yield call(setCookie, 'iShippingCookie', iShippingCookieValue);
    const oldCountry = yield select(
      (state) => state[SESSIONCONFIG_REDUCER_KEY].siteDetails.country
    );
    const oldCurrency = yield select(
      (state) => state[SESSIONCONFIG_REDUCER_KEY].siteDetails.currency
    );
    const oldLanguage = yield select(
      (state) => state[SESSIONCONFIG_REDUCER_KEY].siteDetails.language
    );

    const newSiteId = yield select((state) => state[COUNTRY_SELECTOR_REDUCER_KEY].get('siteId'));
    yield put(udpateSiteId(newSiteId));
    let encodedCookieValue = '';
    try {
      const response = yield call(NavigateXHR, '', {}, '');
      const { encodedCookie = '' } = response && response.data;
      encodedCookieValue = encodedCookie;
    } catch (err) {
      logger.error(err);
    }
    languageRedirect(
      newCountry,
      oldCountry,
      newSiteId,
      newLanguage,
      oldLanguage,
      newCurrency,
      oldCurrency,
      encodedCookieValue
    );
  } catch (error) {
    yield null;
  }
}

function* CountrySelectorSaga() {
  const cachedModuleX = validateReduxCache(fetchModuleX);
  yield takeLatest(GLOBAL_CONSTANT.GET_MODULEX_CONTENT, cachedModuleX);
  yield takeLatest(GLOBAL_CONSTANT.COUNTRY_LIST_GET_DATA, fetchCountryListData);
  yield takeLatest(
    COUNTRY_SELECTOR_CONSTANTS.COUNTRY_SELECTOR_SUBMIT_DATA,
    submitCountrySelectionData
  );
}

export default CountrySelectorSaga;
